import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { Skeleton, Tab, Tabs, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import AnimatedNumber from "../../../Component/AnimatedNumber/AnimatedNumber";
import BrandAuditIndexBreakups from "../../../Component/BrandIndexHistory/BrandAuditIndexBreakups";
import Rankings from "../../../Component/BrandIndexHistory/Rankings";
import SentimentDriversTable from "../../../Component/BrandIndexHistory/SentimentDrivers";
import SentimentTable from "../../../Component/BrandIndexHistory/SentimentTable";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import Header from "../../../Component/Header/Header";
import Modal from "../../../Component/Modal/Modal";
import MUIToolTip from "../../../Component/UI/ActionTooltip/MUIToolTip";
import Alert from "../../../Component/UI/Alert/Alert";
import { AuthContext } from "../../../context/auth-context";
import { metricExplainations } from "../../../utils/constant";
import { extractDomain, transformDriverData } from "../../../utils/helpers";
import AttributesOverview from "../Attributes/AttributesOverview";
import BrandInsights from "../BrandInsights/BrandInsights";
import BrandOverview from "../BrandOverview/BrandOverview";
import CategoryDimensions from "../CategoryDimensions/CategoryDimensions";
import CompetitiveOverview from "../CompetitiveOverview/CompetitiveOverview";
import Competitors from "../Competitors/Competitors";
import CoreAttributes from "../CoreAttributes/CoreAttributes";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import FocusAreaOverView from "../FocusArea/focusArea";
import MarketItem from "../MarketComparison/MarketComparisonForItem";
import MarketOverview from "../MarketOverview/MarketOverview";
import Share from "../Share/Share";
import Sources from "../SourcesV2/Sources";
import Taxonomy from "../Taxonomy/Taxonomy";
import GaugeChart from "./../../../Component/GaugeChart/GaugeChart";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";
import LLMIndicator from "./../LLMIndicator/LLMIndicator";
import classes from "./BrandScore.module.css";
// import CompetitorSummary from "../CompetitorSummary/CompetitorSummary";
import Checkbox from "@mui/material/Checkbox";

export let tab = {
  brandOverview: "nev_brandoverview",
  competitiveOverview: "nev_competitiveoverview",
  marketOverview: "nev_marketoverview",
};

export default function BrandScoreMain({
  categories,
  market,
  llms,
  competitors,
  brand,
}) {
  const discoveryCtx = useContext(DiscoveryContext);

  const [activeTab, setActiveTab] = useState(0);
  // const tab=[
  //   ...categories.map((category, index) => (
  //         {
  //           key:category,
  //           label:categories
  //         }
  //       )),
  //       {
  //         key:"competitor summary",
  //         label:"Competitor Summary"
  //       }

  // ]

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    window.dispatchEvent(new Event("resize"));
    window.dispatchEvent(new Event("tabchange"));
  };

  if (!categories || !llms) return null;
  if (categories.length === 0 || llms.length === 0) return null;

  return (
    <div>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        (
        <Tab
          key={"brand overview"}
          label={"Brand Overview"}
          id={tab.brandOverview}
        />
        ) : null (
        <Tab
          key={"competitive overview"}
          label={"Competitive Overview"}
          id={tab.competitiveOverview}
        />
        ) : null
        {/* (
        <Tab key={"category compare"} label={"Category Comparison"} id="category_comparison" />) : null */}
        {/* {discoveryCtx.markets && discoveryCtx.markets.length > 0 ? (
          <Tab key={"market compare"} label={"Market Comparison"} id="market_comparison" />
        ) : null}  */}
        {discoveryCtx.markets && discoveryCtx.markets.length > 0 ? (
          <Tab
            key={"market overview"}
            label={"Market Overview"}
            id={tab.marketOverview}
          />
        ) : null}
        {categories.map((category, index) => {
          /*allocating dynamic id to category  tab for selection perpose*/
          let categoryKey = category.replace(/\s+/g, "_");
          tab[`${category}`] = `nav_${categoryKey}`;
          return (
            <Tab key={category} label={category} id={tab[`${category}`]} />
          );
        })}
      </Tabs>
      {/* {activeTab === 2 && <CategoryComparison />}  */}
      {activeTab === 0 && <BrandOverview />}
      {activeTab === 1 && <CompetitiveOverview />}
      {activeTab === 2 && <MarketOverview />}

      {categories.map((category, index) => {
        return (
          <CategoryTab
            category={category}
            index={index}
            market={market}
            llms={llms}
            competitors={competitors}
            brand={brand}
            activeTab={activeTab}
          />
        );
      })}
      {/* {activeTab === categories.length+2 && <MarketComparison />}  */}
    </div>
  );
}

function CategoryTab({
  category,
  index,
  market,
  llms,
  competitors,
  brand,
  activeTab,
}) {
  const [showShareModal, setShowShareModal] = useState(false);
  const discoveryCtx = useContext(DiscoveryContext);
  const entity = discoveryCtx.entity;
  const primaryLLM = discoveryCtx.primary_llm;
  const selectedLLM = discoveryCtx.state.selectedLLM;
  let domain = extractDomain(
    discoveryCtx?.competitors?.["default"]?.[0]?.domain ?? "example.com"
  );
  const data =
    discoveryCtx.brand_scores[selectedLLM][category][market]?.[0]?.extras;
  const pdfRef = useRef(null);

  console.log(category, "rendering", "index", index);
  const header = (
    <Header
      title={
        <div className={classes.title_container} id="logo">
          {domain && (
            <img
              className={classes.logo}
              src={`https://img.logo.dev/${domain}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
            />
          )}
          <div className="pt-2">
            <div className={classes.title}>
              <span>{entity}</span>
            </div>
            {category && (
              <div className={classes.label_container}>
                <span className={classes.title_label}>{category}</span>
                {market ? (
                  <>
                    <span>&middot;</span>
                    <span className={classes.title_label}>
                      {market == "GeneralMarket" ? "General Market" : market}
                    </span>
                  </>
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            )}
          </div>
        </div>
      }
      titleClassName={classes.title}
      className={classes.header}
      renderAction={() => {
        return (
          <div className="mx-3">
            {!discoveryCtx.loading && (
              <MUIIconButton
                title="Click to Share"
                className="mx-3"
                onClick={() => setShowShareModal(true)}
              >
                <ShareOutlinedIcon color="primary" />
              </MUIIconButton>
            )}
          </div>
        );
      }}
    />
  );

  const llmSections = (
    <div>
      <BrandScore
        category={category}
        market={market}
        entity={brand}
        llm={selectedLLM}
        llms={llms}
      />
    </div>
  );

  const competitorsData = (
    <div className={classes.section}>
      {competitors[category]?.length > 0 && (
        <Competitors
          category={category}
          entity={brand}
          llm={selectedLLM}
          market={market}
          isCategoryOverview={true}
        />
      )}
    </div>
  );
  const reachData = data?.productRankingsArray && (
    <MUICard className="p-4 mb-4">
      {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h6>Reach Data</h6>
          </div> */}
      <div style={{ display: "flex" }} id="print-pdf" ref={pdfRef}>
        <Rankings
          onRankChange={(e) => {}}
          rankings={data?.productRankingsArray}
          rankMatchesIndices={data?.rankMatchesIndices}
          name={
            data.favorabilities?.length > 0 ? data?.favorabilities[0]?.name : ""
          }
        />
        <hr />
      </div>
    </MUICard>
  );

  const sentimentData = <SentimentTable data={data} showScore={false} />;

  const sentimentDrivers = data && (
    <>
      {data.sentiementKeyDrivers &&
        Object.keys(data.sentiementKeyDrivers).length > 0 && (
          <>
            {/* <hr />
                     <h5>3. Sentiment Drivers</h5> */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "0.5rem",
              }}
            >
              {data.sentiementKeyDrivers?.positive &&
                data.sentiementKeyDrivers?.positive.length > 0 && (
                  <div style={{ flex: 1, minWidth: "40%" }}>
                    <SentimentDriversTable
                      data={transformDriverData(
                        data.sentiementKeyDrivers?.positive,
                        "Positive"
                      )}
                      title="Positive Sentiment Drivers"
                    />
                  </div>
                )}

              {data.sentiementKeyDrivers?.negative &&
                data.sentiementKeyDrivers?.negative.length > 0 && (
                  <div style={{ flex: 1, minWidth: "40%" }}>
                    <SentimentDriversTable
                      data={transformDriverData(
                        data.sentiementKeyDrivers?.negative,
                        "Negative"
                      )}
                      title="Negative Sentiment Drivers"
                    />
                  </div>
                )}
            </div>
          </>
        )}
    </>
  );

  const positiveNegativeAttributes = (
    <div id={`${category}_positivenegative_attributes`}>
      {competitors[category]?.length > 0 && (
        <AttributesOverview category={category} isCategoryOverview={true} />
      )}
    </div>
  );

  const coreAttributes = (
    <div
      className={classes.section_summary}
      style={{ paddingTop: 10, paddingBottom: 10 }}
    >
      <div className={classes.flex_one}>
        {competitors[category]?.length > 0 && (
          <CoreAttributes category={category} entity={entity} />
        )}
      </div>
    </div>
  );

  const taxonomy = (
    <div className={classes.section_summary}>
      <div className={classes.flex_one}>
        {competitors[category]?.length > 0 && (
          <Taxonomy category={category} llm={selectedLLM} />
        )}
      </div>
    </div>
  );

  const taxonomyAndCoreAttributes = () => {
    if (discoveryCtx.type === "brand") {
      return coreAttributes;
    } else {
      return taxonomy;
    }
  };

  const categoryDimensions = (
    <div
      className={classes.section_summary}
      style={{ paddingTop: 10, paddingBottom: 10 }}
    >
      <div className={classes.flex_one}>
        {competitors[category] && competitors[category]?.length > 0 && (
          <CategoryDimensions category={category} entity={entity} />
        )}
      </div>
    </div>
  );

  // const realtimeActions = (
  //   <div className={classes.section} >
  //     {competitors[category] && competitors[category]?.length > 0 && (
  //       <RealtimeActions
  //         category={category}
  //         market={market}
  //         llm={selectedLLM}
  //       />
  //     )}
  //   </div>
  // );

  const realtimeActions = (
    <div className={classes.section}>
      {competitors[category] && competitors[category]?.length > 0 && (
        <FocusAreaOverView category={category} isCategoryOverview={true} />
      )}
    </div>
  );

  const sources = (
    <div className={classes.section}>
      <Sources category={category} market={market} />
    </div>
  );

  const DetailSection = function () {
    let id = `${tab[category]}_BrandInsights`;
    let title = "Brand Insights";
    let uniqueKey = `${tab[category]}_${id}_${discoveryCtx.state.selectedLLM}`;

    const { checked } = useIsSelectedSection({ id, uniqueKey });

    return (
      <>
        <div className="Heading-checkbox">
          <h5>{title}</h5>

          {discoveryCtx.state.showReportCheckbox && (
            <Checkbox
              checked={checked}
              onChange={() => {
                discoveryCtx?.clickComponentCheckbox({
                  uniqueKey,
                  filter: {
                    id: id,
                    title: title,
                    category: category,
                    market: market,
                    tab: tab[category],
                    uniqueKey,
                  },
                  checked,
                  id,
                });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          )}
        </div>
        <div id={id}>
          <MUICard className="p-4 mb-4">
            {header}
            <div className={classes.printSpacing}>
              <BrandInsights
                entity={entity}
                category={category}
                llm={selectedLLM}
              />
            </div>
            {llmSections}
          </MUICard>
        </div>
      </>
    );
  };

  return (
    <div
      key={entity + category + "section"}
      style={{ display: activeTab === index + 3 ? "block" : "none" }}
    >
      <DetailSection />

      {/* <componentWithCheckbox
        id="detail_data"
        title="Detail"
        componentOutput={DetailSection()}
        category={category}
        market={market}
      /> */}
      <div className={classes.pageBreak} />

      <div className={classes.printSpacing}>
        {/* <ComponentWithCheckbox id="Competitor_Analysis" title="Competitor Analysis" componentOutput={competitorsData}
                   category={category}

         />  */}
        {competitorsData}
      </div>

      <ComponentWithCheckbox
      id={`Reach_data`}
        title="Reach Data"
        componentOutput={reachData}
        category={category}
        market={market}
      />

      <div className={classes.pageBreak} />
      <ComponentWithCheckbox
        id="sentiment_data"
        title="Sentiment Data"
        componentOutput={sentimentData}
        category={category}
        market={market}
      />
      <div className={classes.pageBreak} />
      <ComponentWithCheckbox
        id="sentiment_driver"
        title="Sentiment Driver"
        componentOutput={sentimentDrivers}
        category={category}
        market={market}
      />
      <div className={classes.pageBreak} />
      <div className={classes.printSpacing}>
        <ComponentWithCheckbox
          id={
            discoveryCtx.type === "brand" ? "Brand_Piller" : "Product_Dimension"
          }
          title={
            discoveryCtx.type === "brand" ? "Brand Piller" : "Product Dimension"
          }
          componentOutput={taxonomyAndCoreAttributes()}
          category={category}
          market={market}
        />
      </div>

      <ComponentWithCheckbox
        id="purchase_criteria"
        title="Purchase Criteria"
        componentOutput={categoryDimensions}
        category={category}
        market={market}
      />
      <div className={classes.pageBreak} />
      <div className={classes.container}>
        <div className={classes.printSpacing}>
          <div style={{ width: "100%" }}>
            <ComponentWithCheckbox
              id="sources"
              title="Sources"
              componentOutput={sources}
              category={category}
              market={market}
            />
          </div>
        </div>
      </div>
      <div className={classes.pageBreak} />
      <ComponentWithCheckbox
        id="realtimeActions"
        title="Focus Area"
        componentOutput={realtimeActions}
        category={category}
        market={market}
      />

      <div className={classes.container}>
        <div>
          <ComponentWithCheckbox
            id={`positiveNegativeAttributes`}
            title="Positive and Negative Attributes"
            componentOutput={positiveNegativeAttributes}
            category={category}
            market={market}
          />
        </div>
      </div>

      <Modal
        height="60%"
        title="Share Link"
        open={showShareModal}
        handleClose={() => setShowShareModal(false)}
      >
        <Share setShowShareModal={setShowShareModal} />
      </Modal>
    </div>
  );
}

let ComponentWithCheckbox = React.memo(function ({
  id,
  title,
  componentOutput,
  category,
  market,
}) {
  id=`${tab[category]}_${id}`
  const discoveryCtx = useContext(DiscoveryContext);
  let uniqueKey = `${tab[category]}_${id}_${discoveryCtx.state.selectedLLM}`;

  const { checked } = useIsSelectedSection({ id, uniqueKey });

  return (
    <MUICard className=" mb-4">
      <div className="Heading-checkbox">
        <h5>{title}</h5>

        {discoveryCtx.state.showReportCheckbox && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title: title,
                   category: category,
                   market: market,
                  tab: tab[category],
                  uniqueKey,
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}
      </div>
      <hr />
      <div id={id}>{componentOutput}</div>
    </MUICard>
  );
});

function BrandScore({ category, market, llm, llms }) {
  console.log("BrandScore", category, market, llm);
  const [showBrandIndexBreakups, setShowBrandIndexBreakups] = useState(false);
  const [error, setError] = useState(null);
  const { user } = useContext(AuthContext);
  const { license_status } = user?.customer;
  const customer_id = user?.customer_id || 0;
  const language_id = user?.language_id || 1;

  const discoveryCtx = useContext(DiscoveryContext);

  const entity = discoveryCtx.entity;
  console.log("discoveryCtxData", discoveryCtx);
  const primaryLLM = discoveryCtx.primary_llm;
  const otherLLMs = llms.filter((l) => l !== primaryLLM);
  const chartref = useRef();
  const brandScoreCtx = discoveryCtx.brand_scores;
  const rankScoreCtx = discoveryCtx.rank_scores;
  const discoveryType = discoveryCtx.type || "brand";
  const searchParams = new URLSearchParams(window.location.search);
  const isReporting = searchParams.get("isReporting") === "true";
  const abortControllerRef = useRef(null);
  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);

  const brandScoreLength =
    brandScoreCtx[primaryLLM][category][market]?.[0]?.total;

  const saveActions = async (title, rationale, sources) => {};

  const getTooltipProps = (index, metric, sources, score, explanation) => {
    console.log(
      "getTooltipPropsAudit",
      index,
      metric,
      sources,
      score,
      explanation
    );

    return {
      metric: metric,
      attribute: "",
      metricScore: Number(score).toFixed(0),
      selectedInput: {
        llm: primaryLLM,
        market: primaryLLM,
        persona: "General Persona",
        brand: discoveryCtx.entity,
        product: null,
        geography: "",
        category: "",
      },
      sources,
      key: index,
      addToActionHandler: saveActions,
      actionText: "Add To Action",
      title: explanation,
      // isActionLoading: isActionLoading,
      isActionLoading: false,
      arrow: true,
      slotProps: {
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -18],
              },
            },
          ],
        },
      },
    };
  };

  useEffect(() => {
    console.log("BrandScore useEffect", brandScoreLength);
    if (brandScoreLength > 0) {
      console.log("chartref", chartref);
      if (chartref.current) {
        setTimeout(() => chartref.current.resize(), 500);
      }
      return;
    }
    llms.map((llm) => {
      // getBrandIndex(llm);
    });
  }, [entity, brandScoreLength]);

  let brandScore = brandScoreCtx[primaryLLM][category][market][0];
  let rankScore = rankScoreCtx[primaryLLM][category][market];
  let loading = true;
  let domain = "";
  let reachSources = {};
  let sentimentSources = {};
  let variants = [];

  if (brandScore && brandScore.extras && brandScore.total) {
    domain =
      discoveryCtx?.competitors?.[category] &&
      extractDomain(discoveryCtx?.competitors?.[category]?.[0]?.domain);
    variants =
      discoveryCtx?.competitors?.[category]?.[0]?.variants?.filter(
        (v) => v.active
      ) || [];
    loading = false;
  }
  if (brandScore && brandScore.error) {
    loading = false;
  }

  let brandScoreAdjustments = { changed: false };
  if (brandScore?.extras?.rank) {
    const [{ name }] = brandScore?.extras?.rank;
    if (
      name.toString().toLowerCase().trim().replaceAll(" ", "") !==
      discoveryCtx.entity.toString().toLowerCase().trim().replaceAll(" ", "")
    ) {
      brandScoreAdjustments.entities = [name, discoveryCtx.entity];
      brandScoreAdjustments.changed = true;
    }
  }
  if (rankScore && rankScore?.sources?.rank) {
    reachSources[primaryLLM] = rankScore?.sources?.rank ?? [];
  }
  if (brandScore && Array.isArray(brandScore.sentimentSources)) {
    sentimentSources[primaryLLM] = Object.fromEntries(
      brandScore.sentimentSources.map((url, index) => [url, index])
    );
  }

  console.log("reachSources", sentimentSources, reachSources, discoveryCtx);
  console.log("brandScore final", brandScore, loading);
  return (
    <div className={classes.wrapper}>
      <MUICard variant="elevated" elevation={0} className={classes.card}>
        <div className={classes.container}>
          <div className={classes.brand_container}>
            {/* <div className={`${classes.print_only} print-only`}>
              <LLMIndicator llm={llm || "gpt-4o"} />
            </div> */}
            <div className={classes.brand_index_wrapper}>
              <div className={classes.brand_index}>
                <div className={classes.main}>
                  {!loading && brandScore?.extras && !error && (
                    <MUIIconButton
                      data-html2canvas-ignore
                      className={classes.info}
                      onClick={() => setShowBrandIndexBreakups(true)}
                    >
                      <InfoOutlinedIcon />
                    </MUIIconButton>
                  )}
                  <div>
                    <span className={classes.brand_label}>
                      <span className={classes.llm_brand}>
                        {discoveryType === "brand" ? "Brand" : "Product"} Index
                        Score
                      </span>
                      <LLMIndicator llm={primaryLLM || "gpt-4o"} />
                    </span>
                    {loading && !error && <Skeleton width={400} height={350} />}
                    {!loading && brandScore?.total && !error && (
                      <GaugeChart
                        ref={chartref}
                        width={"100%"}
                        height={"330px"}
                        radius={"100%"}
                        center={["50%", "70%"]}
                        data={[{ value: brandScore?.total }]}
                      />
                    )}
                    {error && (
                      <div className={classes.error_view}>
                        <ErrorView
                          title={"Error fetching brand index score"}
                          message={error}
                          retry
                          onRetry={() => {
                            discoveryCtx.updateBrandScores({
                              res: {
                                data: null,
                                index: 0,
                              },
                              req: {
                                category,
                                llm,
                                market,
                              },
                            });
                            // getBrandIndex(llm);
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className={classes.sub}>
                    <div className={classes.score}>
                      <div className={classes.score_content}>
                        {!error && (
                          <Tooltip title={metricExplainations[`Reach`]}>
                            <span className={classes.score_text}>
                              Visibility
                            </span>
                          </Tooltip>
                        )}
                        {!loading && !error && (
                          <div>
                            <MUIToolTip
                              {...getTooltipProps(
                                undefined,
                                "Reach",
                                reachSources,
                                brandScore?.rank
                              )}
                            >
                              <AnimatedNumber
                                className={classes.score_value}
                                start={isReporting? brandScore?.rank||0:0}
                                end={brandScore?.rank || 0}
                                duration={isReporting? 0:1500}
                              />
                              {/* <span className={classes.score_value}>
                                {Number(brandScore?.rank).toFixed(0)}
                              </span> */}
                            </MUIToolTip>
                          </div>
                        )}
                        {loading && !error && (
                          <Skeleton width={90} height={110} />
                        )}
                      </div>
                    </div>
                    {!error && <div className={classes.partition}></div>}
                    <div className={classes.score}>
                      <div className={classes.score_content}>
                        {!error && (
                          <Tooltip title={metricExplainations[`Sentiment`]}>
                            <span className={classes.score_text}>
                              Sentiment
                            </span>
                          </Tooltip>
                        )}
                        {!loading && !error && (
                          <div>
                            <MUIToolTip
                              {...getTooltipProps(
                                undefined,
                                "Sentiment",
                                sentimentSources,
                                brandScore?.favorability
                              )}
                            >
                              <AnimatedNumber
                            className={classes.score_value}
                            start={isReporting? brandScore?.favorability || 0:0}
                            end={brandScore?.favorability || 0}
                             duration={isReporting?0:1500}
                               />
                              {/* <span className={classes.score_value}>
                                {Number(brandScore?.favorability).toFixed(0)}
                              </span> */}
                            </MUIToolTip>
                          </div>
                        )}
                        {loading && !error && (
                          <Skeleton width={90} height={110} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {brandScoreAdjustments.changed && (
                  <Alert
                    title="Visibility Score Adjustment"
                    message={
                      <span>
                        The Visibility score has been calculated using the{" "}
                        {discoveryCtx.type}{" "}
                        <b>{brandScoreAdjustments.entities[0]}</b> rather than{" "}
                        <b>{brandScoreAdjustments.entities[1]}</b>
                      </span>
                    }
                  />
                )}
              </div>
              {/* 
                <div className={classes.summary}>
                <Attributes
                  entity={entity}
                  category={category}
                  market={market}
                  llm={llm}
                /> 
              </div>
              */}
              <div className={classes.summary}>
                <div className={classes.llm_card_grid} id="other_llm">
                  {otherLLMs.map((llm, index) => {
                    const score =
                      discoveryCtx.brand_scores[llm][category][market]?.[0];
                    const Primaryscore =
                      discoveryCtx.brand_scores[primaryLLM][category][
                        market
                      ]?.[0];
                    return (
                      <MarketItem
                        brandIndex={score}
                        llm={llm}
                        category={category}
                        market={market}
                        title={llm}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          open={showBrandIndexBreakups}
          handleClose={() => setShowBrandIndexBreakups(false)}
          width={1200}
        >
          <BrandAuditIndexBreakups
            data={brandScore?.extras}
            isOpen={showBrandIndexBreakups}
            type={discoveryCtx.type}
            llm={primaryLLM}
            category={category}
            market={market}
            setShowBrandIndexBreakups={setShowBrandIndexBreakups}
          />
        </Modal>
      </MUICard>
    </div>
  );
}
